import { render, staticRenderFns } from "./SendType.vue?vue&type=template&id=1c996ee0&scoped=true&"
import script from "./SendType.vue?vue&type=script&lang=js&"
export * from "./SendType.vue?vue&type=script&lang=js&"
import style0 from "./SendType.vue?vue&type=style&index=0&id=1c996ee0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c996ee0",
  null
  
)

export default component.exports